<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        depressed
        icon
        :disabled="!(itemsCount>0)"
        class="mx-1"
        :color="itemsCount>0 ? 'error':'success'"
        v-bind="attrs"
        v-on="on"
        to="comprobantes"
      >
        <v-icon v-if="itemsCount > 0" >
          fa-circle-exclamation
        </v-icon>
        <v-icon v-else>
          fa-circle-check
        </v-icon>
      </v-btn>
    </template>
    <span>{{ itemsCount }} comprobantes sin autorización</span>
  </v-tooltip>
</template>

<script>
import { db } from '@/plugins/firebase'
import { collection, query, where, onSnapshot, Timestamp } from "firebase/firestore"

export default {
  name: 'BtncomprobantesPendientes',
  // props: {
    
  // },
  data: () => ({
    estados: ["CREADO", "RECIBIDA"],
    itemsCount: 0,
    suscribeData: null,
  }),
  computed: {
    numItems () {
      return this.items.length
    }
  },
  mounted () {
    this.getDataCount()
  },
  beforeDestroy () {
		if (this.suscribeData) {
			this.suscribeData()
		}
	},
  methods: {

    async getDataCount() {
      try {
        let diaInicial = Timestamp.fromDate((this.$moment().startOf('month')).toDate());
        let diaFinal = Timestamp.fromDate((this.$moment().endOf('month')).toDate());
        const q = query(
          collection(db, "comprobantes"),
          where("estado", "in", this.estados),
          where("date",">=", diaInicial),
          where("date","<=", diaFinal)
        )
        this.suscribeData = onSnapshot(q, (querySnapshot) => {
          this.itemsCount = querySnapshot.size
        })
      } catch (err) {
        console.error(err)
        this.itemsCount = 0
      }
    },
  }
}
</script>
<style>
</style>
